import WithAuth from "../../hoc/WithAuth";
import OrganizationTable from "../../components/tables/organization/OrganizationTable";

const OrganizationsPage = () => {
  return <OrganizationTable />;
};

export default WithAuth(OrganizationsPage);
